import { FunctionComponent } from 'react';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import useAlliumPending from './useAlliumPending';

const Pending: FunctionComponent = () => {
  useAlliumPending();
  return (
    <PleaseWaitOverlay
      icon="alarm"
      title="Your application has been submitted to our lender, Tandem Bank, and we're just waiting for a decision"
      labelLine1="Please be patient, this shouldn't take long. You'll receive updates here and via email. During regular working hours we'll typically have an update within 10-15 minutes"
      labelLine2={
        <p>
          If you&apos;re having trouble, you can reach out to Ideal4Finance
          loans team directly by clicking the{' '}
          <span className="font-semibold">&quot;Need Help&quot;</span> button in
          the header and calling our loans applications team to get some advice.
        </p>
      }
    />
  );
};

export default Pending;
